module.exports = __webpack_public_path__ + "static/media/fractal-tree.3cb7a74f.JPG";